import Home from "./Home";
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { IdleTimerProvider } from "react-idle-timer";
import { DataProvider } from "./DataContext";
import DetailPage from "./DetailPage";
import ListPage from "./ListPage";
import SleepScreen from "./SleepScreen";

function App() {
  const [isIdle, setIsIdle] = useState(false); // Tracks if the app is idle

  // Handle Idle state
  const handleIdle = () => {
    setIsIdle(true); // Show SleepScreen when idle
  };

  const handleActive = () => {
    setIsIdle(false); // Stop showing SleepScreen on activity
  };

  const activateIdleTimer = () => {
    setIsIdle(false); // Manually deactivate idle state
  };

  return (
    <DataProvider>
      {isIdle ? (
        <SleepScreen activateIdleTimer={activateIdleTimer} />
      ) : (
        <IdleTimerProvider
          timeout={240000}
          onIdle={handleIdle}
          onActive={handleActive}
          debounce={250}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/list/:id" element={<ListPage />} />
            <Route path="/detail/:id" element={<DetailPage />} />
          </Routes>
        </IdleTimerProvider>
      )}
    </DataProvider>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
